/**
 * Gesvalt Formularios - GTM Tracking Module
 * Maneja el envío de eventos al dataLayer de Google Tag Manager
 */

(function() {
    'use strict';

    /**
     * Clase para manejar el tracking de GTM
     */
    class GesvaltGTMTracker {
        constructor() {
            this.dataLayer = window.dataLayer || [];
            this.isGTMAvailable = typeof window.gtag !== 'undefined' || window.dataLayer;
            this.init();
        }

        init() {
            // Inicializar dataLayer si no existe
            if (!window.dataLayer) {
                window.dataLayer = [];
                this.dataLayer = window.dataLayer;
            }

            console.log('GesvaltGTMTracker initialized. GTM available:', this.isGTMAvailable);
        }

        /**
         * Envía un evento de envío de formulario al dataLayer
         * @param {HTMLFormElement} form - El formulario que se está enviando
         * @param {Object} formData - Datos del formulario (opcional)
         */
        trackFormSubmission(form, formData = {}) {
            if (!this.isGTMAvailable) {
                console.warn('GTM no está disponible. Evento no enviado.');
                return;
            }

            try {
                // Extraer información completa del formulario
                const formInfo = this.extractCompleteFormInfo(form, formData);
                
                // Crear el evento para el dataLayer
                const eventData = {
                    event: 'form_submit',
                    form_id: formInfo.formId,
                    form_name: formInfo.formName,
                    form_type: 'gesvalt_formularios',
                    page_url: window.location.href,
                    page_title: document.title,
                    timestamp: new Date().toISOString(),
                    ...formInfo.trackingData
                };

                // Enviar al dataLayer
                this.dataLayer.push(eventData);
                
                console.log('GTM Event sent:', eventData);
                
                // También disparar evento personalizado para otros listeners
                this.dispatchCustomEvent(form, eventData);
                
            } catch (error) {
                console.error('Error enviando evento GTM:', error);
            }
        }

        /**
         * Extrae información completa del formulario (metadatos + datos seguros)
         * @param {HTMLFormElement} form 
         * @param {Object} formData - Datos opcionales del formulario
         * @returns {Object}
         */
        extractCompleteFormInfo(form, formData = {}) {
            // Metadatos del formulario
            const formId = form.id || form.dataset.formId || 'unknown';
            const formName = form.name || form.className || 'gesvalt-form';
            const formClasses = form.className;

            // Datos seguros para tracking
            const trackingData = this.extractSafeFormData(form, formData);

            return {
                formId,
                formName,
                formClasses,
                trackingData
            };
        }

        /**
         * Extrae solo los campos seguros del formulario para tracking
         * @param {HTMLFormElement} form 
         * @param {Object} formData - Datos opcionales del formulario
         * @returns {Object}
         */
        extractSafeFormData(form, formData = {}) {
            const trackingData = {};
            
            // Campos seguros para tracking (sin datos personales)
            const safeFields = [
                'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
                'desde_url', 'source_title', 'form_type', 'lead_type'
            ];

            // Extraer de formData si está disponible
            safeFields.forEach(fieldName => {
                if (formData[fieldName]) {
                    trackingData[fieldName] = formData[fieldName];
                }
            });

            // Extraer de campos del formulario si formData no está disponible o incompleto
            if (Object.keys(trackingData).length === 0) {
                const formElements = form.querySelectorAll('input, select, textarea');
                formElements.forEach(element => {
                    if (safeFields.includes(element.name) && element.value) {
                        trackingData[element.name] = element.value;
                    }
                });
            }

            return trackingData;
        }

        /**
         * Dispara un evento personalizado del DOM
         * @param {HTMLFormElement} form 
         * @param {Object} eventData 
         */
        dispatchCustomEvent(form, eventData) {
            const customEvent = new CustomEvent('gesvalt:form:submitted', {
                detail: eventData,
                bubbles: true
            });
            form.dispatchEvent(customEvent);
        }

        /**
         * Envía un evento de error de validación
         * @param {HTMLFormElement} form 
         * @param {Array} errors 
         */
        trackValidationError(form, errors) {
            if (!this.isGTMAvailable) return;

            try {
                const formInfo = this.extractCompleteFormInfo(form);
                
                const eventData = {
                    event: 'gesvalt_form_validation_error',
                    form_id: formInfo.formId,
                    form_name: formInfo.formName,
                    error_count: errors.length,
                    error_fields: errors.join(', '),
                    page_url: window.location.href,
                    timestamp: new Date().toISOString()
                };

                this.dataLayer.push(eventData);
                console.log('GTM Validation Error Event sent:', eventData);
                
            } catch (error) {
                console.error('Error enviando evento de validación GTM:', error);
            }
        }

        /**
         * Método público para tracking manual
         * @param {string} eventName 
         * @param {Object} eventData 
         */
        trackCustomEvent(eventName, eventData = {}) {
            if (!this.isGTMAvailable) return;

            const customEventData = {
                event: `gesvalt_${eventName}`,
                timestamp: new Date().toISOString(),
                page_url: window.location.href,
                ...eventData
            };

            this.dataLayer.push(customEventData);
            console.log('GTM Custom Event sent:', customEventData);
        }
    }

    // Crear instancia global
    const gtmTracker = new GesvaltGTMTracker();

    // Exponer API pública
    window.GesvaltGTMTracker = GesvaltGTMTracker;
    window.gesvaltGTMTracker = gtmTracker;

    // Exponer para uso en otros módulos
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = gtmTracker;
    }

})();